$(($) => {
	const clientsLink = $('.clients-list li a');
	clientsLink.mouseenter(() => {
		$('.start-marquee').css('animation-play-state', 'paused');
	});
	clientsLink.mouseleave(() => {
		$('.start-marquee').css('animation-play-state', 'unset');
	});
});
